<div class="submitting-order-container">
  <ng-lottie [options]="{path: '/assets/lottie/submitting_order.json'}"></ng-lottie>
  <h1>{{'desc.submitting.your.order' | translate}}</h1>
</div>
